export default __webpack_public_path__ + "static/media/tipo-pagamento.c16b4c36.png";